import VesselColour from "../../Enums/VesselColour";
const AircraftIcon = {}; // vessel icon names as found in the mapbox style
AircraftIcon[VesselColour.WHITE] = {
	standard: "aircraft-white-standard",
	highlight: "aircraft-white-highlight"
};
AircraftIcon[VesselColour.BLACK] = {
	standard: "aircraft-black-standard",
	highlight: "aircraft-black-highlight"
};
AircraftIcon[VesselColour.BROWN] = {
	standard: "aircraft-brown-standard",
	highlight: "aircraft-brown-highlight"
};
AircraftIcon[VesselColour.DARKBLUE] = {
	standard: "aircraft-darkblue-standard",
	highlight: "aircraft-darkblue-highlight"
};
AircraftIcon[VesselColour.DARKGREEN] = {
	standard: "aircraft-darkgreen-standard",
	highlight: "aircraft-darkgreen-highlight"
};
AircraftIcon[VesselColour.DARKRED] = {
	standard: "aircraft-darkred-standard",
	highlight: "aircraft-darkred-highlight"
};
AircraftIcon[VesselColour.GRAY] = {
	standard: "aircraft-gray-standard",
	highlight: "aircraft-gray-highlight"
};
AircraftIcon[VesselColour.LIGHTBLUE] = {
	standard: "aircraft-lightblue-standard",
	highlight: "aircraft-lightblue-highlight"
};
AircraftIcon[VesselColour.LIGHTGREEN] = {
	standard: "aircraft-lightgreen-standard",
	highlight: "aircraft-lightgreen-highlight"
};
AircraftIcon[VesselColour.LIGHTRED] = {
	standard: "aircraft-lightred-standard",
	highlight: "aircraft-lightred-highlight"
};
AircraftIcon[VesselColour.MAGENTA] = {
	standard: "aircraft-magenta-standard",
	highlight: "aircraft-magenta-highlight"
};
AircraftIcon[VesselColour.ORANGE] = {
	standard: "aircraft-orange-standard",
	highlight: "aircraft-orange-highlight"
};
AircraftIcon[VesselColour.PURPLE] = {
	standard: "aircraft-purple-standard",
	highlight: "aircraft-purple-highlight"
};
AircraftIcon[VesselColour.SALMON] = {
	standard: "aircraft-salmon-standard",
	highlight: "aircraft-salmon-highlight"
};
AircraftIcon[VesselColour.VIOLET] = {
	standard: "aircraft-violet-standard",
	highlight: "aircraft-violet-highlight"
};
AircraftIcon[VesselColour.YELLOW] = {
	standard: "aircraft-yellow-standard",
	highlight: "aircraft-yellow-highlight"
};
AircraftIcon.helpers = {
	toColor: (icon) => {
		const parts = icon.split("-");
		const color = parts[1];
		if (color === "lightred") {
			return "red";
		}
		return color;
	}
};
export default AircraftIcon;
